import { Grid, TextField } from "@mui/material";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import styled from "styled-components";
import { PrimaryButton } from "../../Layouts/ButtonsControlled";
import { FormHeading } from "../../Layouts/Heading";
import * as yup from "yup";
import { useEffect } from "react";
import LoadingAnimation from "../../Components/LottieAnimation/LoadingAnimation";
import {
    CreateNewSunlightRate,
    sunlightRatesReset,
} from "../../Redux/Finance/SunlightRates/SunlightRatesSlice";

const CreateSunlightRates = () => {
    const dispatch = useDispatch();
    const { isLoading, isSuccess, isError, errors } = useSelector(
        (state) => state.adders
    );

    const validationSchema = yup.object({});
    const formik = useFormik({
        initialValues: {
            name: "",
            term: "",
            apr: 0.0,
            dealer_fee: "",
            pmts_first_year: "",
            pmts_other_years: "",
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            values.submit = true;

            await dispatch(CreateNewSunlightRate(values));
            await dispatch(sunlightRatesReset());
        },
    });

    useEffect(() => {
        if (isError) {
            if (errors) {
                Object.keys(errors).forEach((key) => {
                    let error = errors[key][0];
                    toast.error(error);
                });
            }
            const reset = async () => {
                await dispatch(sunlightRatesReset());
            };
            reset();
        }
    }, [dispatch, errors, isError]);

    useEffect(() => {
        if (isSuccess && formik.values.submit) {
            toast.success("Created successfully");
            formik.values.name = "";
        }
    }, [formik.values, isSuccess]);

    useEffect(() => {
        if (isError) {
            if (errors) {
                Object.keys(errors).forEach((key) => {
                    let error = errors[key][0];
                    toast.error(error);
                });
            }
            const reset = async () => {
                await dispatch(sunlightRatesReset());
            };
            reset();
        }
    }, [isError]);

    return (
        <>
            {isLoading && <LoadingAnimation />}
            {!isLoading && (
                <FormContainer>
                    <FormHeading> Add New Sunlight Rate </FormHeading>
                    <form onSubmit={formik.handleSubmit}>
                        <Grid container columns={12} spacing={3}>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="name"
                                    name="name"
                                    label="Name"
                                    value={formik.values.name}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.name &&
                                        Boolean(formik.errors.name)
                                    }
                                    helperText={
                                        formik.touched.name &&
                                        formik.errors.name
                                    }
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="term"
                                    name="term"
                                    label="Term"
                                    type="number"
                                    value={formik.values.term}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.term &&
                                        Boolean(formik.errors.term)
                                    }
                                    helperText={
                                        formik.touched.term &&
                                        formik.errors.term
                                    }
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    type="number"
                                    id="apr"
                                    name="apr"
                                    label="APR"
                                    value={formik.values.apr}
                                    step={1.0}
                                    variant="outlined"
                                    inputProps={{
                                        maxLength: 13,
                                        step: "1",
                                    }}
                                    onChange={formik.handleChange}
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="dealer_fee"
                                    name="dealer_fee"
                                    label="Dealer Fee"
                                    value={formik.values.dealer_fee}
                                    type="number"
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.dealer_fee &&
                                        Boolean(formik.errors.dealer_fee)
                                    }
                                    helperText={
                                        formik.touched.dealer_fee &&
                                        formik.errors.dealer_fee
                                    }
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="pmts_first_year"
                                    name="pmts_first_year"
                                    label="PMTS First Year"
                                    value={formik.values.pmts_first_year}
                                    type="number"
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.pmts_first_year &&
                                        Boolean(formik.errors.pmts_first_year)
                                    }
                                    helperText={
                                        formik.touched.pmts_first_year &&
                                        formik.errors.pmts_first_year
                                    }
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="pmts_other_years"
                                    name="pmts_other_years"
                                    label="PMTS Other Year"
                                    value={formik.values.pmts_other_years}
                                    type="number"
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.pmts_other_years &&
                                        Boolean(formik.errors.pmts_other_years)
                                    }
                                    helperText={
                                        formik.touched.pmts_other_years &&
                                        formik.errors.pmts_other_years
                                    }
                                />
                            </Grid>
                        </Grid>
                        <PrimaryButton fullWidth type="submit">
                            {isLoading
                                ? "loading ... "
                                : " Add New Sunlight Rate"}
                        </PrimaryButton>
                    </form>
                </FormContainer>
            )}
        </>
    );
};

const FormContainer = styled.div`
    padding: 1rem;
`;
export default CreateSunlightRates;
